import { CardInfoCombinedProps } from './types';

const usePresenter = (props: CardInfoCombinedProps): CardInfoCombinedProps => {
  return props;
};

export default usePresenter;
